<div class="contenedor">

    <div class="centered-chip-list"  *ngIf="dataSource.data.length == 0 && !loading">
        <mat-chip-listbox class="mat-mdc-chip-set-stacked" aria-label="states" multiple>
            <div *ngFor="let group of groupsStates" class="chip-group-wrapper" style="margin-right: 8px;">
              <div class="chip-group">
                <mat-chip-option
                  (selectionChange)="onChipSelectionChange(group.id, $event.selected)"
                  appSimulationStyle
                  [selected]="group.selected"
                  [status]="group.id"
                  [typeStyle]="'B'"
                  [isSelected]="selectedIdsGrups.has(group.id)">
                  {{ group.name }}
                </mat-chip-option>
              </div>
            </div>
          </mat-chip-listbox>          
    </div>

    <div class="contenedorTab">
        <div style="text-align: center;" *ngIf="dataSource.data.length == 0 && !loading">
            <h3>No Se Encontararon Cotizaciones</h3>
        </div>
        
        <div class="spinner">
            <mat-spinner style="margin-top: 50px;" [diameter]="60" *ngIf="load"></mat-spinner>
        </div>
        
        <div class="overflow-table" [ngClass]="{ oculto: dataSource.data.length == 0 }">
            <table mat-table matSort (matSortChange)="changeSorting($event)" [dataSource]="dataSource">
        
                <ng-container matColumnDef="code">
                    <th mat-sort-header="Code" class="th-header" mat-header-cell *matHeaderCellDef>
                        Código
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6><span style="background-color: #f1f1f1; border-radius: 12px; padding: 6px;">{{ element.code }}</span></h6>
                    </td>
                </ng-container>
        
                <ng-container matColumnDef="statusName">
                    <th mat-sort-header="StatusName" class="th-header" mat-header-cell *matHeaderCellDef>
                        Estado
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <ng-container [ngSwitch]="element.statusId">
                            <span *ngSwitchCase="-12" matTooltip="{{element.statusName}}" matTooltipClass="custom-tooltip" class="status" appSimulationStyle [status]="element.statusId">Lista</span>
                            <span *ngSwitchCase="-11" matTooltip="{{element.statusName}}" matTooltipClass="custom-tooltip" class="status" appSimulationStyle [status]="element.statusId">Pendiente</span>
                            <span *ngSwitchCase="-10" matTooltip="{{element.statusName}}" matTooltipClass="custom-tooltip" class="status" appSimulationStyle [status]="element.statusId">{{ element.statusName }}</span>
                            <span *ngSwitchCase="-9" matTooltip="{{element.statusName}}" matTooltipClass="custom-tooltip" class="status" appSimulationStyle [status]="element.statusId">$ Rechazado</span>
                            <span *ngSwitchCase="-8" matTooltip="{{element.statusName}}" matTooltipClass="custom-tooltip" class="status" appSimulationStyle [status]="element.statusId">$ Aprobado</span>
                            <span *ngSwitchCase="-7" matTooltip="{{element.statusName}}" matTooltipClass="custom-tooltip" class="status" appSimulationStyle [status]="element.statusId">$ Solicitado</span>
                            <span *ngSwitchCase="-6" matTooltip="{{element.statusName}}" matTooltipClass="custom-tooltip" class="status" appSimulationStyle [status]="element.statusId">{{ element.statusName }}</span>
                            <span *ngSwitchCase="-5" matTooltip="{{element.statusName}}" matTooltipClass="custom-tooltip" class="status" appSimulationStyle [status]="element.statusId">{{ element.statusName }}</span>
                            <span *ngSwitchCase="-4" matTooltip="{{element.statusName}}" matTooltipClass="custom-tooltip" class="status" appSimulationStyle [status]="element.statusId">{{ element.statusName }}</span>
                            <span *ngSwitchCase="-3" matTooltip="{{element.statusName}}" matTooltipClass="custom-tooltip" class="status" appSimulationStyle [status]="element.statusId">{{ element.statusName }}</span>
                            <span *ngSwitchCase="-2" matTooltip="{{element.statusName}}" matTooltipClass="custom-tooltip" class="status" appSimulationStyle [status]="element.statusId">Enviada</span>
                            <span *ngSwitchCase="-1" matTooltip="{{element.statusName}}" matTooltipClass="custom-tooltip" class="status" appSimulationStyle [status]="element.statusId">{{ element.statusName }}</span>
                            <span *ngSwitchDefault matTooltip="{{element.statusName}}" matTooltipClass="custom-tooltip" class="status" appSimulationStyle [status]="element.statusId">{{ element.statusName }}</span>
                          </ng-container>
                    </td>
                </ng-container>
        
                <ng-container matColumnDef="client">
                    <th mat-sort-header="Customer.Name" class="th-header" mat-header-cell *matHeaderCellDef>
                        Cliente
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{ element.customer.name }}</h6>
                        <h6>{{ element.customer.rut }}</h6>
                    </td>
                </ng-container>
        
                <ng-container matColumnDef="amount">
                    <th mat-sort-header="TotalAmountCLP" class="th-header" mat-header-cell *matHeaderCellDef>
                        Monto
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{ element.totalAmountCLP | currency : "CLP" : "symbol" }}</h6>
                    </td>
                </ng-container>
        
                <ng-container matColumnDef="finalPrice">
                    <th mat-sort-header="FinalPrice" class="th-header" mat-header-cell *matHeaderCellDef>
                        Precio Final
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{ element.currency.symbol }} {{ element.finalPrice | number:'1.0-2' }}</h6>
                    </td>
                </ng-container>
        
                <ng-container matColumnDef="averageRate">
                    <th mat-sort-header="AverageRate" class="th-header" mat-header-cell *matHeaderCellDef>
                        Tasa Anual
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{ (element.averageRate * 100) | number:'1.0-2' }}%</h6>
                    </td>
                </ng-container>
        
                <ng-container matColumnDef="ir">
                    <th class="th-header" mat-header-cell *matHeaderCellDef>
                        IR% 
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{ (element.finalPrice  / element.totalAmountCLP) * 100 | number: '1.0-2' }}%</h6>
                    </td>
                </ng-container>
        
                <ng-container matColumnDef="executiveName">
                    <th mat-sort-header="OriginatorUser.Name" class="th-header" mat-header-cell *matHeaderCellDef>
                        Ejecutivo
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{ element.originatorUser.name }}</h6>
                    </td>
                </ng-container>
        
                <ng-container matColumnDef="createdAt">
                    <th mat-sort-header="CreatedAt" class="th-header" mat-header-cell *matHeaderCellDef>
                        Creada
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{ element.createdAt | date : 'dd/MM/yyyy' }}</h6>
                    </td>
                </ng-container>
        
                <tr mat-header-row *matHeaderRowDef="displayCols"></tr>
                <tr mat-row [cdkContextMenuTriggerFor]="menu" *matRowDef="let row; columns: displayCols" class="cursor-table" style="cursor: pointer;" (click)="openModalDetaiSimulation(row)">
        
                    <ng-template #menu>
                        <div cdkMenu class="context_menu mat-elevation-z0" style="z-index: 999">
        
                        </div>
                    </ng-template>
                </tr>
            </table>
        </div>
        <div>
            <mat-paginator (page)="changePagination($event)" [disabled]="loadPaginador" [pageSizeOptions]="[5, 10, 20, 100]"></mat-paginator>
        </div>
    </div>
</div>